import React, { useRef, useEffect,useState} from "react";
import styled from "styled-components";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { CSSTransition } from 'react-transition-group';
import { useNavigate } from 'react-router-dom';
import { Flex, Divider, Switch, Select, Tooltip, Typography, ConfigProvider } from "antd";
import i18n from 'i18next';

import FormHeader from "../form/FormHeader";
import FormField from "../form/FormField";
import FormText from "../form/FormText";
import FormTitle from "../form/FormTitle";
import FormButton from "../form/FormButton";
import FormInput from "../form/FormInput";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormRemark from "../form/FormRemark";
import InformationIcon from "../core/InformationIcon";
import useApplyNewStore from "../../store/useApplyNewStore";
import ShadowBox from "../core/ShadowBox";
import FormSelect from "../form/FormSelect";
import FormLabel from "../form/FormLabel";
import FormCheckbox from "../form/FormCheckbox";
import FormBigCheckbox2 from "../form/FormBigCheckbox2";
import FormRadioButton from "../form/FormRadioButton";
import FormInputError from "../form/FormInputError";
import FormDatePicker from "../form/FormDatePicker";
import FormTextarea from "../form/FormTextarea";
import FormButtonPrimary from "../form/FormButtonPrimary";
import useViewStore from "../../store/useViewStore";
import useModalStore from "../../store/useModalStore";
import Space from "../core/Space";
import formatCurrency from "../../function/formatCurrency";
import { isProduction } from "../../setting";
import useDropDownHideScroll from '../../hooks/useDropDownHideScroll'
import {mobileWidth} from '../../constant/index'

function Step1() {
  const { t } = useTranslation();
  const { Text } = Typography;
  const { isMobileView, isPadView } = useViewStore();
  const { openModalConfirm } = useModalStore();
  const { hospitalList, step1_section2_hospitalid, step1_section2_hospitalid_error, setStep1_section2_hospitalid, setStep1_section2_hospitalid_error } = useApplyNewStore();
  const { step1_section2_attendDoctor, step1_section2_attendDoctor_error, setStep1_section2_attendDoctor, setStep1_section2_attendDoctor_error } = useApplyNewStore();
  const { step1_section2_isBxNetwork, setStep1_section2_isBxNetwork } = useApplyNewStore();
  const { step1_section2_operationloctype, setStep1_section2_operationloctype } = useApplyNewStore();
  const { step1_section2_location, step1_section2_location_error, setStep1_section2_location, setStep1_section2_location_error } = useApplyNewStore();
  const { step1_section2_otherhopsital, step1_section2_otherhopsital_error, setStep1_section2_otherhopsital, setStep1_section2_otherhopsital_error } = useApplyNewStore();
  const { step1_section2_housingclass, step1_section2_housingclass_error, setStep1_section2_housingclass, setStep1_section2_housingclass_error } = useApplyNewStore();
  const { step1_section3_admissiondt, step1_section3_admissiondt_error, setStep1_section3_admissiondt, setStep1_section3_admissiondt_error } = useApplyNewStore();
  const { step1_section3_surgeryBudgetRemark, setStep1_section3_surgeryBudgetRemark } = useApplyNewStore();
  const { step1_section3_provideMedicalExpense, step1_section3_provideMedicalExpense_error, setStep1_section3_provideMedicalExpense, setStep1_section3_provideMedicalExpense_error } = useApplyNewStore();
  const { step1_section3_surgeonfee, step1_section3_surgeonfee_checkbox, step1_section3_surgeonfee_error, setStep1_section3_surgeonfee, setStep1_section3_surgeonfee_checkbox, setStep1_section3_surgeonfee_error } = useApplyNewStore();
  const { step1_section3_anesthesiologistfee, step1_section3_anesthesiologistfee_checkbox, step1_section3_anesthesiologistfee_error, setStep1_section3_anesthesiologistfee, setStep1_section3_anesthesiologistfee_checkbox, setStep1_section3_anesthesiologistfee_error } = useApplyNewStore();
  const { step1_section3_operatingrmfee, step1_section3_operatingrmfee_checkbox, step1_section3_operatingrmfee_error, setStep1_section3_operatingrmfee, setStep1_section3_operatingrmfee_checkbox, setStep1_section3_operatingrmfee_error } = useApplyNewStore();
  const { step1_section3_housetourfee, step1_section3_hosmisousfee_checkbox, step1_section3_housetourfee_error, setStep1_section3_housetourfee, setStep1_section3_hosmisousfee_checkbox, setStep1_section3_housetourfee_error } = useApplyNewStore();
  const { step1_section3_hosmisousfee, step1_section3_hosmisousfee_error, setStep1_section3_hosmisousfee, setStep1_section3_hosmisousfee_error } = useApplyNewStore();
  const { step1_section3_noofdays, step1_section3_noofdays_error, setStep1_section3_noofdays, setStep1_section3_noofdays_error } = useApplyNewStore();
  const { step1_section3_housetourfee_noofdays_checkbox, setStep1_section3_housetourfee_noofdays_checkbox } = useApplyNewStore();
  const { step1_scrollTo, setStep1_scrollTo } = useApplyNewStore();
  const { isLogCase, getPreAuthFormData, resetStep, goNextStep } = useApplyNewStore();
  const {
    step1_section2_disease,
    step1_section2_disease_error,
    setStep1_section2_disease,
    setStep1_section2_disease_remove,
    setStep1_section2_disease_set_error,
    setStep1_section2_surgery,
    setStep1_section2_surgery_remove,
    setStep1_section2_surgery_set_error,
    validateStep1,
    isStep1Valid,
    validateStep4,
    setStep4_pay_accept,
  } = useApplyNewStore();
  const { step1_notToPaid, setStep1_notToPaid, saveFormStep1 } = useApplyNewStore();
  const { findDiseaseByCode, findSurgeriesByCode } = useApplyNewStore();
  const navigate = useNavigate();

  const diseaseMaxLength = 3;
  const surgeryMaxLength = 3;
  const isDisableAddDisease = step1_section2_disease.length >= diseaseMaxLength;
  const nodeRefProvideMedicalExpense = useRef(null);

  const calculateTotal = () => {
    const surgeonfee = step1_section3_surgeonfee_checkbox && step1_section3_surgeonfee ? parseFloat(step1_section3_surgeonfee) : 0;
    const anesthesiologistfee = step1_section3_anesthesiologistfee_checkbox && step1_section3_anesthesiologistfee ? parseFloat(step1_section3_anesthesiologistfee) : 0;
    const operatingrmfee = step1_section3_operatingrmfee_checkbox && step1_section3_operatingrmfee ? parseFloat(step1_section3_operatingrmfee) : 0;
    const housetourfee = step1_section3_housetourfee_noofdays_checkbox && step1_section3_housetourfee ? parseFloat(step1_section3_housetourfee) : 0;
    const hosmisousfee = step1_section3_hosmisousfee_checkbox && step1_section3_hosmisousfee ? parseFloat(step1_section3_hosmisousfee) : 0;
    const noofdays = step1_section3_housetourfee_noofdays_checkbox && step1_section3_noofdays ? parseFloat(step1_section3_noofdays) : 0;

    return formatCurrency(surgeonfee + anesthesiologistfee + operatingrmfee + hosmisousfee + (housetourfee * noofdays));
  }

  const nodeRefArea1 = useRef(null);
  const nodeRefArea2 = useRef(null);
  const nodeRefArea3 = useRef(null);
  const nodeRefArea4 = useRef(null);
  const nodeRefArea5 = useRef(null);

  useEffect(() => {
    const scrollToField = (fieldRef) => {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' });
      setStep1_scrollTo("");
    };

    const fieldRefs = {
      area1: nodeRefArea1,
      area2: nodeRefArea2,
      area3: nodeRefArea3,
      area4: nodeRefArea4,
    };

    if (step1_scrollTo && fieldRefs[step1_scrollTo]) {
      scrollToField(fieldRefs[step1_scrollTo]);
    }
  }, [step1_scrollTo]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { handleOpen, handleClose } = useDropDownHideScroll();
  const [isMobile] = useState(
    Math.floor(window.innerWidth) <= mobileWidth
  );
  return (
    <Container>
      <PageTitle>
        <FormHeader style={{ margin: 0 }}>{t("translation:apply.nav.Step1Title")}</FormHeader>
      </PageTitle>

      <Content>
        <PreviousPageBtn onClick={() => {
          openModalConfirm({
            title: t("translation:apply.nav.exitTitle"),
            text: t("translation:apply.nav.exitContent"),
            callback: () => {
              resetStep();
              navigate(`${process.env.PUBLIC_URL}/${i18n.language}`, { replace: true });
            }
          });
        }}>
          <Img24 src={`${process.env.PUBLIC_URL}/images/arrow_l.svg`} alt={t("previous")} />
          <PreviousPageBtnText>{t("previous")}</PreviousPageBtnText>
        </PreviousPageBtn>

        <Section>
          <Flex gap={8} align="center">
            <Img32 src={`${process.env.PUBLIC_URL}/images/document-tray.svg`} alt={t("translation:apply.step1.section1.title")} />
            <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>{t("translation:apply.step1.section1.title")}</FormTitle>
          </Flex>

          <Flex vertical gap={16} style={{ width: "100%" }}>
            <Flex vertical={isMobileView} gap={16} style={{ width: "100%" }}>
              <Flex flex={1} vertical>
                <FormRemark>{t("translation:apply.step1.section1.F1")}</FormRemark>
                <FormText>{getPreAuthFormData.user.IDPLNO || "-"}</FormText>
              </Flex>
              <Flex flex={1} vertical>
                <FormRemark>{t("translation:apply.step1.section1.F2")}</FormRemark>
                <FormText>{getPreAuthFormData.user.IDINSN || "-"} {getPreAuthFormData.user.DEPENDCODE ? `(${getPreAuthFormData.user.DEPENDCODE})` : ""}</FormText>
              </Flex>
            </Flex>

            <Flex vertical={isMobileView} gap={16} style={{ width: "100%" }}>
              <Flex flex={1} vertical>
                <FormRemark>{t("translation:apply.step1.section1.F3")}</FormRemark>
                <FormText>{getPreAuthFormData.user.userName || "-"}</FormText>
              </Flex>
              <Flex flex={1} vertical>
                <FormRemark>{t("translation:apply.step1.section1.F4")}</FormRemark>
                <FormText>{getPreAuthFormData?.user?.userDOB?.substr(0, 10) || "-"}</FormText>
              </Flex>
            </Flex>
          </Flex>
        </Section>

        <Section>
          <Flex gap={8} align="center">
            <Img32 src={`${process.env.PUBLIC_URL}/images/document-clip.svg`} alt={t("translation:apply.step1.section2.title")} />
            <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>{t("translation:apply.step1.section2.title")}</FormTitle>
          </Flex>

          <ShadowTipDiv>
            <Img20 src={`${process.env.PUBLIC_URL}/images/tanhaosvg.svg`} /> 
            <span style={{lineHeight:"20px"}}>
                {t("translation:apply.step1.section1.tip")}
            </span>
          </ShadowTipDiv>

          <Area ref={nodeRefArea1} vertical gap={16} style={{ scrollMarginTop: 90 }}>
            <AreaTitle orientation="left" orientationMargin="0" style={{ borderColor: 'var(--aia-bx-medium-blue-20)', margin: 0 }}>
              <Flex gap={8}>
                <Img24 src={`${process.env.PUBLIC_URL}/images/product_all-in-one.svg`} alt={t("translation:apply.step1.section2.area1.title")} />
                <FormTitle style={{ color: "var(--aia-bx-blue-3)" }}>{t("translation:apply.step1.section2.area1.title")}</FormTitle>
              </Flex>
            </AreaTitle>

            {/* {JSON.stringify(step1_section2_disease)} */}

            {
              step1_section2_disease.map((item, index) => {
                const surgeryCodeArray = item.surgeryCode.split(",");
                const diseaseCodeArray = step1_section2_disease.map(item => item.diseaseCode);
                const diseaseCode = item.diseaseCode.includes("|") ? item.diseaseCode.split("|")[0] : item.diseaseCode;
                const surgeryItemsLength = diseaseCode ? getPreAuthFormData?.SurgeryOption.find(opt => opt.diseaseCode === diseaseCode).options.length : surgeryMaxLength;
                const curentSelectableSurgeryLength = item.surgeryCode.split(",")?.length;
                const isDisableAddSurgery = !item.diseaseCode || surgeryCodeArray[surgeryCodeArray.length - 1] === "" || surgeryCodeArray.length >= surgeryMaxLength || curentSelectableSurgeryLength >= surgeryItemsLength;

                const selectedDiseaseCode = item.diseaseCode.includes("|") ? item.diseaseCode.split("|")[0] : (item.diseaseCode || null);
                const otherDiseaseText = item.diseaseCode.includes("|") ? item.diseaseCode.split("|")[1] : null;
                const isDiseaseShowOther = findDiseaseByCode(selectedDiseaseCode)?.diseaseShowOther === "Y";

                return (
                  <DiseaseBlock key={index}>
                    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                      <DiseaseBlockTitle>{t("translation:apply.step1.section2.area1.disease")}</DiseaseBlockTitle>

                      {
                        index > 0 && <FormButton style={{ marginRight: 24 }} onClick={() => {
                          setStep1_section2_disease_remove(index);
                          validateStep1(true);
                        }}>
                          <Flex gap={2} align="center">
                            <Img24 src={`${process.env.PUBLIC_URL}/images/bin.svg`} alt={t("remove")} />
                            <Text style={{ color: "var(--aia-bx-grey-50)", fontSize: 12, lineHeight: "18ox" }}>{t("remove")}</Text>
                          </Flex>
                        </FormButton>
                      }
                    </Flex>

                    <DiseaseBlockContent>

                      <DiseaseBlockFormField style={{ marginBottom: 8 }}>
                        <FormLabelBold>{t("translation:apply.step1.section2.area1.Q1")}</FormLabelBold>
                        {/* {JSON.stringify(diseaseCodeArray)} */}
                        <Flex gap={8} align="center">
                          <Select 
                            onDropdownVisibleChange={(isOpen) => {
                              isOpen ? handleOpen() : handleClose();
                            }}
                            listHeight={isMobile ? 140 :256}
                            placeholder={t("pleaseSelect", { key: t("translation:apply.step1.section2.area1.Q1") })}
                            size={"large"}
                            showSearch 
                            id="apply_step1_q1"
                            // allowClear
                            defaultValue={null}
                            optionFilterProp="title"
                            style={{ flex: 1, overflow: "hidden" }}
                            value={selectedDiseaseCode}
                            options={getPreAuthFormData?.diseaseOption?.map((diseaseOption) => {
                              return {
                                label: <Text ellipsis style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: 12, cursor: "default" }}>{`${diseaseOption.categoryNameInZh} ${diseaseOption.categoryNameInEn}`}</Text>,
                                title: `${diseaseOption.categoryNameInZh} ${diseaseOption.categoryNameInEn}`,
                                options: diseaseOption.options.filter(option => !diseaseCodeArray.map(item => item.includes("|") ? item.split("|")[0] : item).includes(option.diseaseCode) || option.diseaseCode === selectedDiseaseCode)?.map((option) => {
                                  return {
                                    label: <Flex vertical gap={0} style={{ marginLeft: 5 }}>
                                      <Text ellipsis style={{ color: "var(--aia-bx-dark-blue)" }}>{option.diseaseZh}</Text>
                                      <Text ellipsis style={{ fontSize: 12, color: "var(--aia-bx-dark-blue)" }}>{option.diseaseEn}</Text>
                                    </Flex>,
                                    title: `${option.diseaseZh} ${option.diseaseEn}`,
                                    value: option.diseaseCode
                                  }
                                })
                              }
                            })}
                            onChange={(value) => {
                              const isOther = findDiseaseByCode(value)?.diseaseShowOther === "Y";
                              setStep1_section2_disease(index, isOther ? `${value}|` : (value ?? ""), selectedDiseaseCode);
                              setStep1_section2_disease_set_error(index, false);
                              validateStep1(true);
                            }}
                          />

                          {
                            !isMobileView && <div style={{ width: 44, height: 44 }} />
                          }
                        </Flex>

                        {
                          isDiseaseShowOther && <>
                            <Space height={10}></Space>

                            <Flex gap={8} align="center">
                              <Flex vertical style={{ width: "100%" }}>
                                <FormInput value={otherDiseaseText} handleChange={(e) => {
                                  setStep1_section2_disease(index, `${selectedDiseaseCode}|${e.target.value}`);
                                  setStep1_section2_disease_set_error(index, false);
                                  validateStep1(true);
                                }} placeholder={t("pleaseInput", { key: t("translation:apply.step1.section2.area2.Q1_placeholder") })} aria-label={t("translation:apply.step1.section2.area2.Q1")} id="apply_step1_q1_otherdesease"
                                />
                                {/* <FormInputError show={isDiseaseShowOther && step1_section2_disease_error[index]?.diseaseCode}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area1.Q1") })}</FormInputError> */}
                              </Flex>

                              {
                                !isMobileView && <div style={{ width: 44, height: 44 }} />
                              }
                            </Flex>
                          </>
                        }

                        {
                          (isMobileView && findDiseaseByCode(item.diseaseCode)) &&
                          <Flex vertical gap={0} style={{ marginTop: 5 }}>
                            <Text style={{ fontSize: 12, lineHeight: "18px", color: "var(--aia-bx-grey-60)" }}>{findDiseaseByCode(item.diseaseCode).diseaseZh}</Text>
                            <Text style={{ fontSize: 12, lineHeight: "18px", color: "var(--aia-bx-grey-60)" }}>{findDiseaseByCode(item.diseaseCode).diseaseEn}</Text>
                          </Flex>
                        }
                        {/* {JSON.stringify(step1_section2_disease_error[index]?.diseaseCode)} */}
                        {/* <FormInputError show={!isDiseaseShowOther && step1_section2_disease_error[index]?.diseaseCode}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area1.Q1") })}</FormInputError> */}
                      </DiseaseBlockFormField>

                      <DiseaseBlockFormField>
                        {/* {JSON.stringify(surgeryCodeArray)} */}
                        <FormLabelBold style={{ marginBottom: 4 }}>{t("translation:apply.step1.section2.area1.Q2")}</FormLabelBold>
                        <FormLabel style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:apply.step1.section2.area1.Q2_remark")}</FormLabel>

                        <Flex gap={8} vertical>
                          {
                            surgeryCodeArray.map((surgeryCode, surgeryIndex) => {
                              const surgeryCodeOptions = getPreAuthFormData.SurgeryOption.filter(option => option.diseaseCode === selectedDiseaseCode)[0]?.options;

                              const selectedSurgeryCode = surgeryCode.includes("|") ? surgeryCode.split("|")[0] : (surgeryCode || null);
                              const otherSurgeryText = surgeryCode.includes("|") ? surgeryCode.split("|")[1] : null;
                              const isSurgeryShowOther = findSurgeriesByCode(selectedDiseaseCode, [selectedSurgeryCode])[0]?.surgeryShowOther === "Y";

                              return (
                                <Flex vertical key={`${index}-${surgeryIndex}`}>
                                  <Flex gap={8} align="center">
                                    <Flex vertical gap={8} style={{ width: "100%", overflow: "hidden" }}>
                                      <Select 
                                        listHeight={isMobile ? 140 :256}
                                        onDropdownVisibleChange={(isOpen) => {
                                            isOpen ? handleOpen() : handleClose();
                                        }}
                                        placeholder={item.diseaseCode ? t("pleaseSelect", { key: t("translation:apply.step1.section2.area1.Q2") }) : t("pleaseSelectFirst", { key: t("translation:apply.step1.section2.area1.Q1") })}
                                        size={"large"}
                                        showSearch
                                        // allowClear
                                        defaultValue={null}
                                        optionFilterProp="title"
                                        style={{ flex: 1, overflow: "hidden" }}
                                        disabled={!item.diseaseCode}
                                        value={selectedSurgeryCode}
                                        options={surgeryCodeOptions?.filter(option => !surgeryCodeArray.map(item => item.includes("|") ? item.split("|")[0] : item).includes(option.surgeryCode) || option.surgeryCode === selectedSurgeryCode)?.map((item) => {
                                          return {
                                            label: <Flex vertical gap={0} style={{ marginLeft: 5 }}>
                                              <Text ellipsis style={{ color: "var(--aia-bx-dark-blue)" }}>{item.surgeryZh}</Text>
                                              <Text ellipsis style={{ fontSize: 12, color: "var(--aia-bx-dark-blue)" }}>{item.surgeryEn}</Text>
                                            </Flex>,
                                            title: `${item.surgeryZh} ${item.surgeryEn}`,
                                            value: item.surgeryCode
                                          }
                                        })}
                                        onChange={(value) => {
                                          const isOther = findSurgeriesByCode(selectedDiseaseCode, [value])[0]?.surgeryShowOther === "Y";

                                          setStep1_section2_surgery(index, surgeryIndex, isOther ? `${value}|` : (value ?? ""));
                                          setStep1_section2_surgery_set_error(index, surgeryIndex, false);
                                          validateStep1(true);
                                        }} 
                                        id="apply_step1_surgery_to_be_performed"
                                        className="apply_step_one_surgical_select"
                                      />

                                      {
                                        isSurgeryShowOther &&
                                        <Flex vertical style={{ width: "100%" }}>
                                          <FormInput value={otherSurgeryText} handleChange={(e) => {
                                            setStep1_section2_surgery(index, surgeryIndex, `${selectedSurgeryCode}|${e.target.value}`);
                                            setStep1_section2_surgery_set_error(index, surgeryIndex, false);
                                            validateStep1(true);
                                          }} placeholder={t("pleaseInput", { key: t("translation:apply.step1.section2.area2.Q1_placeholder") })} aria-label={t("translation:apply.step1.section2.area2.Q1")} id="apply_step1_othersurgery_to_be_performed"/>
                                          {/* <FormInputError show={isSurgeryShowOther && step1_section2_disease_error[index]?.surgeryCode[surgeryIndex]}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area1.Q2") })}</FormInputError> */}
                                        </Flex>
                                      }
                                    </Flex>

                                    {
                                      (!isMobileView || (isMobileView && surgeryCodeArray.length > 1)) &&
                                      <FormButton style={{ padding: 10, alignSelf: "flex-start", visibility: isMobileView || surgeryCodeArray.length > 1 ? "visible" : "hidden" }} onClick={() => {
                                        setStep1_section2_surgery_remove(index, surgeryIndex);
                                        validateStep1(true);
                                      }}>
                                        <Img32 src={`${process.env.PUBLIC_URL}/images/bin.svg`} style={{ width: 24, height: 24 }} alt={t("translation:apply.step1.section1.title")} />
                                      </FormButton>
                                    }
                                  </Flex>

                                  {
                                    (isMobileView && findSurgeriesByCode(item.diseaseCode, [surgeryCode]).length > 0) &&
                                    <Flex vertical gap={0} style={{ marginTop: 5 }}>
                                      <Text style={{ fontSize: 12, lineHeight: "18px", color: "var(--aia-bx-grey-60)" }}>{findSurgeriesByCode(item.diseaseCode, [surgeryCode])[0].surgeryZh}</Text>
                                      <Text style={{ fontSize: 12, lineHeight: "18px", color: "var(--aia-bx-grey-60)" }}>{findSurgeriesByCode(item.diseaseCode, [surgeryCode])[0].surgeryEn}</Text>
                                    </Flex>
                                  }
                                  {/* {JSON.stringify(step1_section2_disease_error[index]?.surgeryCode[surgeryIndex])} */}
                                  {/* <FormInputError show={
                                    !isSurgeryShowOther && !step1_section2_disease_error[index]?.diseaseCode && step1_section2_disease_error[index]?.surgeryCode[surgeryIndex]}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area1.Q2") })}</FormInputError> */}
                                </Flex>
                              )
                            })
                          }
                        </Flex>
                      </DiseaseBlockFormField>

                      <FormButtonSecondary disabled={isDisableAddSurgery} onClick={() => {
                        if (!isDisableAddSurgery) {
                          setStep1_section2_surgery(index, surgeryCodeArray.length, "");
                          validateStep1(true);
                        }
                      }} style={{ width: isMobileView ? "100%" : "fit-content", padding: "6px 24px", border: isDisableAddSurgery ? "1px solid var(--aia-bx-grey-90)" : "revert-layer", background: isDisableAddSurgery ? "rgba(0, 0, 0, 0.13)" : "revert-layer" }}>
                        <Img24 src={`${process.env.PUBLIC_URL}/images/plus_blue.svg`} alt={t("translation:apply.step1.section2.area1.Q2_add")} />
                        <FormText style={{ color: "var(--aia-bx-dark-blue)" }}>{t("translation:apply.step1.section2.area1.Q2_add")}</FormText>
                      </FormButtonSecondary>
                    </DiseaseBlockContent>
                  </DiseaseBlock>
                )
              })
            }

            {/* {JSON.stringify(step1_section2_disease_error)} */}

            <Flex justify="space-between" vertical={isMobileView} gap={8}>
              <Flex vertical>
                <FormTitle style={{ color: "var(--aia-bx-light-black)" }}>{t("translation:apply.step1.section2.area1.disease_add_title")}</FormTitle>
                <FormText style={{ fontSize: 12, lineHeight: "18px", color: "var(--aia-bx-light-black)" }}>{t("translation:apply.step1.section2.area1.disease_add_title_remark")}</FormText>
              </Flex>
              <FormButtonSecondary disabled={isDisableAddDisease} onClick={() => {
                if (!isDisableAddDisease) {
                  setStep1_section2_disease(step1_section2_disease.length, "");
                  validateStep1(true);
                }
              }} style={{ width: isMobileView ? "100%" : "fit-content", padding: "6px 24px", border: isDisableAddDisease ? "1px solid var(--aia-bx-grey-90)" : "revert-layer", background: isDisableAddDisease ? "rgba(0, 0, 0, 0.13)" : "revert-layer" }}>
                <Img24 src={`${process.env.PUBLIC_URL}/images/plus_blue.svg`} alt={t("translation:apply.step1.section2.area1.Q2_add")} />
                <FormText style={{ color: "var(--aia-bx-dark-blue)" }}>{t("translation:apply.step1.section2.area1.disease_add")}</FormText>
              </FormButtonSecondary>
            </Flex>
          </Area>

          <Area ref={nodeRefArea2} vertical gap={16} style={{ scrollMarginTop: 90 }}>
            <AreaTitle orientation="left" orientationMargin="0" style={{ borderColor: 'var(--aia-bx-medium-blue-20)', margin: 0 }}>
              <Flex gap={8}>
                <Img24 src={`${process.env.PUBLIC_URL}/images/product_all-in-one.svg`} alt={t("translation:apply.step1.section2.area2.title")} />
                <FormTitle style={{ color: "var(--aia-bx-blue-3)" }}>{t("translation:apply.step1.section2.area2.title")}</FormTitle>
              </Flex>
            </AreaTitle>

            <FormField style={{ marginBottom: 0, width: "100%" }}>
              <FormLabelBold htmlFor="docterName">{t("translation:apply.step1.section2.area2.Q1")}</FormLabelBold>
              <FormInput id="docterName" value={step1_section2_attendDoctor} handleChange={e => {
                setStep1_section2_attendDoctor_error(false);
                setStep1_section2_attendDoctor(e.target.value);
                validateStep1(true);
              }} placeholder={t("pleaseInput", { key: t("translation:apply.step1.section2.area2.Q1_placeholder") })} aria-label={t("translation:apply.step1.section2.area2.Q1")} />
              {/* <FormInputError show={step1_section2_attendDoctor_error}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area2.Q1") })}</FormInputError> */}
            </FormField>

            <FormCheckbox active={step1_section2_isBxNetwork} onClick={() => {
              setStep1_section2_isBxNetwork(!step1_section2_isBxNetwork);
            }} id="apply_step1_used_bx_medicalcard">{t("translation:apply.step1.section2.area2.Q2")}</FormCheckbox>
          </Area>

          <Area ref={nodeRefArea3} vertical gap={16} style={{ scrollMarginTop: 90 }}>
            <AreaTitle orientation="left" orientationMargin="0" style={{ borderColor: 'var(--aia-bx-medium-blue-20)', margin: 0 }}>
              <Flex gap={8}>
                <Img24 src={`${process.env.PUBLIC_URL}/images/medical-bed.svg`} alt={t("translation:apply.step1.section2.area3.title")} />
                <FormTitle style={{ color: "var(--aia-bx-blue-3)" }}>{t("translation:apply.step1.section2.area3.title")}</FormTitle>
              </Flex>
            </AreaTitle>

            <FormField style={{ marginBottom: 0, width: "100%" }}>
              <FormLabelBold>{t("translation:apply.step1.section2.area3.Q1")}</FormLabelBold>
              <Flex vertical={isMobileView} gap={16}>
                <FormBigCheckbox2
                  flex={1}
                  onClick={() => {
                    setStep1_section2_operationloctype("HOSPITAL");
                    validateStep1(true);
                  }}
                  active={step1_section2_operationloctype === "HOSPITAL"}
                  title={t("translation:apply.step1.section2.area3.Q1_Option1")} 
                  id="apply_1_surgical_in_hospital"
                />
                <FormBigCheckbox2
                  flex={1}
                  onClick={() => {
                    setStep1_section2_operationloctype("DAYCENTRE");
                    validateStep1(true);
                  }}
                  active={step1_section2_operationloctype === "DAYCENTRE"}
                  title={t("translation:apply.step1.section2.area3.Q1_Option2")}
                  id="apply_1_surgical_in_daycenter"
                />
              </Flex>
            </FormField>

            {
              step1_section2_operationloctype === "HOSPITAL" &&
              <FormField style={{ marginBottom: 0, width: "100%" }}>
                <FormLabelBold>{t("translation:apply.step1.section2.area3.Q2")}</FormLabelBold>
                {/* 手术地点 todo*/}
                <Flex>
                  <FormRadioButton onClick={() => {
                    setStep1_section2_location("HKMU");
                    validateStep1(true);
                  }} active={step1_section2_location === "HKMU"} id="apply_step1_surgical_location_hk">{t("translation:apply.step1.section2.area3.Q2_Option1")}</FormRadioButton>
                  <Space />
                  <FormRadioButton onClick={() => {
                    setStep1_section2_location("OTHER");
                    validateStep1(true);
                  }} active={step1_section2_location === "OTHER"} id="apply_step1_surgical_location_oversea">{t("translation:apply.step1.section2.area3.Q2_Option2")}</FormRadioButton>
                </Flex>
                {/* <FormInputError show={step1_section2_location_error}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area3.Q2") })}</FormInputError> */}
              </FormField>
            }

            {
              (step1_section2_operationloctype === "HOSPITAL" && step1_section2_location === "HKMU") &&
              <FormField style={{ marginBottom: 0, width: "100%" }}>
                <FormLabelBold>{t("translation:apply.step1.section2.area3.Q3")}</FormLabelBold>
                {/* <FormSelect
                  value={step1_section2_hospitalid}
                  options={hospitalList.map(item => {
                    return {
                      value: item.hid,
                      label: i18n.language === "ch" ? item.chi_name : item.eng_name,
                      color: item.hid ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-50)",
                    }
                  })}
                  handleSelect={(value) => {
                    setStep1_section2_hospitalid(value);
                    setStep1_section2_hospitalid_error(false);
                    validateStep1(true);
                  }}
                /> */}
                <ConfigProvider
                  theme={{
                    token: {
                      colorText: "var(--aia-bx-medium-blue-60)"
                    },
                  }}
                >
                  <Select
                    onDropdownVisibleChange={(isOpen) => {
                       isOpen ? handleOpen() : handleClose();
                    }}
                    placeholder={t("pleaseSelect", { key: t("translation:apply.step1.section2.area3.Q3") })}
                    size={"large"}
                    showSearch
                    // allowClear
                    defaultValue={null}
                    optionFilterProp="title"
                    style={{ flex: 1, width: "100%", overflow: "hidden" }}
                    value={step1_section2_hospitalid?.value || null}
                    options={hospitalList.map(item => {
                      return {
                        value: item.hid,
                        label: i18n.language === "ch" ? item.chi_name : item.eng_name,
                        title: i18n.language === "ch" ? item.chi_name : item.eng_name,
                      }
                    })}
                    onChange={(value) => {
                      setStep1_section2_hospitalid({ value: value, label: hospitalList.find(item => item.hid === value)?.chi_name });
                      setStep1_section2_hospitalid_error(false);
                      validateStep1(true);
                    }}
                    id="apply_step1_surgical_hospital"
                    listHeight={isMobile ? 140 :256}
                  />
                </ConfigProvider>
                {/* <FormInputError show={step1_section2_hospitalid_error}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area3.Q3") })}</FormInputError> */}
              </FormField>
            }

            {
              ((step1_section2_operationloctype === "HOSPITAL" && (step1_section2_location === "OTHER" || step1_section2_hospitalid?.value === "00000000000000000000000000000000")) || step1_section2_operationloctype === "DAYCENTRE") &&
              <FormField style={{ marginBottom: 0, width: "100%" }}>
                <FormLabelBold htmlFor="hospitalName">{t("translation:apply.step1.section2.area3.Q4")}</FormLabelBold>
                <FormInput id="hospitalName" value={step1_section2_otherhopsital} handleChange={e => {
                  setStep1_section2_otherhopsital_error(false);
                  setStep1_section2_otherhopsital(e.target.value);
                  validateStep1(true);
                }} placeholder={t("pleaseInput", { key: t("translation:apply.step1.section2.area3.Q4") })} aria-label={t("translation:apply.step1.section2.area3.Q4")} />
                {/* <FormInputError show={step1_section2_otherhopsital_error}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area3.Q4") })}</FormInputError> */}
              </FormField>
            }

            <FormField style={{ marginBottom: 0, width: "100%" }}>
              <FormLabelBold>{t("translation:apply.step1.section2.area3.Q5")}</FormLabelBold>
              <Flex style={{ flexWrap: "wrap" }} gap={8}>
                <FormRadioButton onClick={() => {
                  setStep1_section2_housingclass("REGULAR");
                  setStep1_section2_housingclass_error(false);
                  validateStep1(true);
                }} id="apply_step1_regular_room" active={step1_section2_housingclass === "REGULAR"}>{t("translation:apply.step1.section2.area3.Q5_Option1")}</FormRadioButton>
                <FormRadioButton onClick={() => {
                  setStep1_section2_housingclass("SEMI");
                  setStep1_section2_housingclass_error(false);
                  validateStep1(true);
                }} id="apply_step1_semi_private_room" active={step1_section2_housingclass === "SEMI"}>{t("translation:apply.step1.section2.area3.Q5_Option2")}</FormRadioButton>
                <FormRadioButton onClick={() => {
                  setStep1_section2_housingclass("PRIVATE");
                  setStep1_section2_housingclass_error(false);
                  validateStep1(true);
                }} id="apply_step1_private_room" active={step1_section2_housingclass === "PRIVATE"}>{t("translation:apply.step1.section2.area3.Q5_Option3")}</FormRadioButton>
                <FormRadioButton onClick={() => {
                  setStep1_section2_housingclass("DAYCASE");
                  setStep1_section2_housingclass_error(false);
                  validateStep1(true);
                }} id="apply_step1_day_center" active={step1_section2_housingclass === "DAYCASE"}>{t("translation:apply.step1.section2.area3.Q5_Option4")}</FormRadioButton>
                <FormRadioButton onClick={() => {
                  setStep1_section2_housingclass("OUTPATIENT_CLINICAL");
                  setStep1_section2_housingclass_error(false);
                  validateStep1(true);
                }} id="apply_step1_outpatient_clinic" active={step1_section2_housingclass === "OUTPATIENT_CLINICAL"}>{t("translation:apply.step1.section2.area3.Q5_Option5")}</FormRadioButton>
              </Flex>
              {/* <FormInputError show={step1_section2_housingclass_error}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area3.Q5") })}</FormInputError> */}
            </FormField>

            <FormField style={{ marginBottom: 0, width: "100%" }}>
              <Flex gap={8}>
                <FormLabelBold htmlFor="A3Q6">{t("translation:apply.step1.section2.area3.Q6")}</FormLabelBold>

                <Tooltip title={t("translation:apply.step1.section2.area3.Q6_tooltip")}>
                  <InformationIcon id="tip2" style={{ margin: 0, cursor: "default" }}>i</InformationIcon>
                </Tooltip>
              </Flex>
              <FormDatePicker
                id="A3Q6"
                inputReadOnly
                minDate={dayjs(getPreAuthFormData.earliestAdmissionLOGDate.substring(0, 10))}
                maxDate={dayjs(getPreAuthFormData.maxAdmissionDate.substring(0, 10))}
                value={step1_section3_admissiondt ? dayjs(step1_section3_admissiondt) : null}
                onChange={(date, dateString) => {
                  setStep1_section3_admissiondt(dateString);
                  setStep1_section3_admissiondt_error(false);
                  validateStep1(true);
                }}
                placeholder="YYYY-MM-DD"
              />
              {/* <FormInputError show={step1_section3_admissiondt_error}>* {t("pleaseSelect", { key: t("translation:apply.step1.section2.area3.Q6") })}</FormInputError> */}
            </FormField>

            <FormField style={{ marginBottom: 0, width: "100%" }}>
              <FormLabelBold htmlFor="A3Q7">{t("translation:apply.step1.section2.area3.Q7")}</FormLabelBold>
              <FormTextarea id="A3Q7" value={step1_section3_surgeryBudgetRemark} style={{ resize: "vertical" }} onChange={(e) => {
                setStep1_section3_surgeryBudgetRemark(e.target.value);
              }} rows="5" placeholder={t("translation:apply.step1.section2.area3.Q7")} aria-label={t("translation:apply.step1.section2.area3.Q7")} />
            </FormField>
          </Area>

          <Area ref={nodeRefArea4} vertical gap={16} style={{ scrollMarginTop: 90 }}>
            <AreaTitle orientation="left" orientationMargin="0" style={{ borderColor: 'var(--aia-bx-medium-blue-20)', margin: 0 }}>
              <Flex gap={8}>
                <Img24 src={`${process.env.PUBLIC_URL}/images/medical-bed.svg`} alt={t("translation:apply.step1.section2.area4.title")} />
                <FormTitle style={{ color: "var(--aia-bx-blue-3)" }}>{t("translation:apply.step1.section2.area4.title")}</FormTitle>
              </Flex>
            </AreaTitle>

            <ShadowBox style={{ backgroundColor: "var(--aia-bx-blue-5)", flexDirection: "column", alignItems: "flex-start", gap: 0 }}>
              <Flex gap={8} vertical>
                <FormText>{t("translation:apply.step1.section2.area4.Q1")}</FormText>
                <Flex vertical>
                  <FormLabel htmlFor="provideMedicalExpense" style={{ gap: 8 }}>
                    <Switch id="provideMedicalExpense" value={step1_section3_provideMedicalExpense} onChange={() => {
                      setStep1_section3_provideMedicalExpense(!step1_section3_provideMedicalExpense);
                      setStep1_section3_provideMedicalExpense_error(false);
                      validateStep1(true);
                    }} style={{ width: "fit-content" }} />
                    <FormText style={{ cursor: "pointer" }}>{t("translation:apply.step1.section2.area4.Q1_option")}</FormText>
                  </FormLabel>
                  {/* <FormInputError show={step1_section3_provideMedicalExpense_error} style={{ margin: 0 }}>* {t("please", { key: t("translation:apply.step1.section2.area4.Q1_option") })}</FormInputError> */}
                </Flex>
              </Flex>

              <CSSTransition
                nodeRef={nodeRefProvideMedicalExpense}
                in={step1_section3_provideMedicalExpense}
                timeout={250}
                classNames="fade"
                unmountOnExit
                exit={false}
              >
                <>
                  <Space height={8} />

                  <Flex vertical gap={8} style={{ width: "100%", marginBottom: 8 }}>
                    <AreaTitle orientation="left" orientationMargin="0" style={{ borderColor: 'var(--aia-bx-medium-blue-20)', margin: 0 }}>
                      <Flex gap={8}>
                        <FormText style={{ color: "var(--aia-bx-blue-3)", fontWeight: "bold" }}>{t("translation:apply.step1.section2.area4.Q2")}</FormText>
                      </Flex>
                    </AreaTitle>

                    <Flex vertical gap={isMobileView ? 16 : 8} style={{ width: "100%" }}>
                      <Flex gap={4} vertical={isMobileView} justify={"space-between"} style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_surgeonfee_checkbox} onClick={() => {
                          setStep1_section3_surgeonfee_checkbox(!step1_section3_surgeonfee_checkbox);
                          setStep1_section3_surgeonfee_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true);
                        }} 
                        id="apply_step1_surgical_doctor_checkbox">{t("translation:apply.step1.section2.area4.Q2_option1")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_surgeonfee}
                            handleChange={e => {
                              setStep1_section3_surgeonfee_error(false);
                              setStep1_section3_surgeonfee(e.target.value);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            prefix="HK$"
                            placeholder="0"
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_surgeonfee_checkbox}
                            id="apply_step1_surgical_doctor_input"
                          />
                          {/* <FormInputError show={step1_section3_surgeonfee_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option1") })}</FormInputError> */}
                        </Flex>
                      </Flex>

                      <Flex gap={4} vertical={isMobileView} justify="space-between" style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_anesthesiologistfee_checkbox} onClick={() => {
                          setStep1_section3_anesthesiologistfee_checkbox(!step1_section3_anesthesiologistfee_checkbox);
                          setStep1_section3_anesthesiologistfee_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true);
                        }} id="apply_step1_anesthesiologist_doctor_checkbox">{t("translation:apply.step1.section2.area4.Q2_option2")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_anesthesiologistfee}
                            handleChange={e => {
                              setStep1_section3_anesthesiologistfee_error(false);
                              setStep1_section3_anesthesiologistfee(e.target.value);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            prefix="HK$"
                            placeholder="0"
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_anesthesiologistfee_checkbox}
                            id="apply_step1_anesthesiologist_doctor_input"
                          />
                          {/* <FormInputError show={step1_section3_anesthesiologistfee_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option2") })}</FormInputError> */}
                        </Flex>
                      </Flex>

                      <Flex gap={4} vertical={isMobileView} justify="space-between" style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_operatingrmfee_checkbox} onClick={() => {
                          setStep1_section3_operatingrmfee_checkbox(!step1_section3_operatingrmfee_checkbox);
                          setStep1_section3_operatingrmfee_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true);
                        }} id="apply_step1_operating_checkbox">{t("translation:apply.step1.section2.area4.Q2_option3")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_operatingrmfee}
                            handleChange={e => {
                              setStep1_section3_operatingrmfee_error(false);
                              setStep1_section3_operatingrmfee(e.target.value);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            prefix="HK$"
                            placeholder="0"
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_operatingrmfee_checkbox}
                            id="apply_step1_operating_input"
                          />
                          {/* <FormInputError show={step1_section3_operatingrmfee_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option3") })}</FormInputError> */}
                        </Flex>
                      </Flex>

                      <Flex gap={4} vertical={isMobileView} justify="space-between" style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_hosmisousfee_checkbox} onClick={() => {
                          setStep1_section3_hosmisousfee_checkbox(!step1_section3_hosmisousfee_checkbox);
                          setStep1_section3_hosmisousfee_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true);
                        }} id="apply_step1_miscellaneous_checkbox">{t("translation:apply.step1.section2.area4.Q2_option4")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_hosmisousfee}
                            handleChange={e => {
                              setStep1_section3_hosmisousfee_error(false);
                              setStep1_section3_hosmisousfee(e.target.value);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            prefix="HK$"
                            placeholder="0"
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_hosmisousfee_checkbox} 
                            id="apply_step1_miscellaneous_input"
                          />
                          {/* <FormInputError show={step1_section3_hosmisousfee_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option4") })}</FormInputError> */}
                        </Flex>
                      </Flex>

                      <Flex gap={4} vertical={isMobileView} justify="space-between" style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_housetourfee_noofdays_checkbox} onClick={() => {
                          setStep1_section3_housetourfee_noofdays_checkbox(!step1_section3_housetourfee_noofdays_checkbox);
                          setStep1_section3_housetourfee_error(false);
                          setStep1_section3_noofdays_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true); 
                         }} id="apply_step1_room_inspection_checkbox">{t("translation:apply.step1.section2.area4.Q2_option5")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_housetourfee}
                            handleChange={e => {
                              setStep1_section3_housetourfee(e.target.value);
                              setStep1_section3_housetourfee_error(false);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            prefix="HK$"
                            placeholder="0"
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_housetourfee_noofdays_checkbox} 
                            id="apply_step1_room_inspection_input"
                          />
                          {/* <FormInputError show={step1_section3_housetourfee_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option5") })}</FormInputError> */}
                        </Flex>
                      </Flex>

                      <Flex gap={4} vertical={isMobileView} justify="space-between" style={{ width: "100%" }}>
                        <FormCheckbox active={step1_section3_housetourfee_noofdays_checkbox} onClick={() => {
                          setStep1_section3_housetourfee_noofdays_checkbox(!step1_section3_housetourfee_noofdays_checkbox);
                          setStep1_section3_housetourfee_error(false);
                          setStep1_section3_noofdays_error(false);
                          setStep1_section3_provideMedicalExpense_error(false);
                          validateStep1(true);
                        }} id="apply_step1_expected_day_checkbox">{t("translation:apply.step1.section2.area4.Q2_option6")}</FormCheckbox>
                        <Flex vertical align="flex-end">
                          <FormInput
                            value={step1_section3_noofdays}
                            handleChange={e => {
                              setStep1_section3_noofdays(e.target.value);
                              setStep1_section3_noofdays_error(false);
                              validateStep1(true);
                            }}
                            type="number"
                            inputMode="decimal"
                            min={"0"}
                            onKeyDown={(e) => (e.key === '-' || e.key === 'e') && e.preventDefault()}
                            placeholder="0"
                            suffix={t("translation:apply.step1.section2.area4.Q2_option6_suffix", { count: parseFloat(1) || 0 })}
                            style={{ width: isMobileView ? "100%" : 250, padding: "6px 16px" }}
                            disabled={!step1_section3_housetourfee_noofdays_checkbox} 
                            id="apply_step1_expected_day_input"
                          />
                          {/* <FormInputError show={step1_section3_noofdays_error} style={{ textAlign: "right" }}>* {t("pleaseInput", { key: t("translation:apply.step1.section2.area4.Q2_option6") })}</FormInputError> */}
                        </Flex>
                      </Flex>
                    </Flex>

                    <Flex justify="flex-end" style={{ width: "100%" }}><b>{t("translation:apply.step1.section2.area4.total")} HK$ {calculateTotal()}</b></Flex>
                  </Flex>
                </>
              </CSSTransition>

            </ShadowBox>
          </Area>
        </Section>

        {
          isLogCase() &&
          <Section>
            <FormField ref={nodeRefArea5} style={{ width: "100%", margin: 0, scrollMarginTop: 90 }}>
              <Flex gap={8} align="center">
                <Img32 src={`${process.env.PUBLIC_URL}/images/receipt.svg`} alt={t("translation:apply.step1.section3.title")} />
                <FormTitle>{t("translation:apply.step1.section3.title")}</FormTitle>
              </Flex>

              <FormText style={{ margin: "8px 0px" }}>{t("translation:apply.step1.section3.subtitle")}</FormText>

              <FormLabel htmlFor="S2Q1" style={{ gap: 8 }}>
                <Switch id="S2Q1" defaultChecked value={!step1_notToPaid} onChange={() => {
                  setStep1_notToPaid(!step1_notToPaid);
                  setStep4_pay_accept(false);
                  validateStep4(true);
                }} />
                <span style={{ cursor: "pointer" }}>{t("translation:apply.step1.section3.Q1")}</span>
              </FormLabel>
            </FormField>
          </Section>
        }

        <Flex gap={8} vertical={isMobileView} style={{ width: "100%", margin: isMobileView ? "8px 0px" : "32px 0px", flexDirection: isMobileView ? "column-reverse" : "row" }}>
          <Flex flex={1} justify={isMobileView ? "center" : ""}>
            <SaveButton onClick={saveFormStep1} style={{ width: "fit-content" }}>
              <Img24 src={`${process.env.PUBLIC_URL}/images/floppy.svg`} alt="Save" />
              <SaveButtonText>{t("save")}</SaveButtonText>
            </SaveButton>
          </Flex>
          <Flex flex={1} justify="center">
            <FormButtonPrimary id={isProduction ? "pre_auth_next_step_btn_1" : "pre_auth_uat_next_step_btn_1"} onClick={() => {
              validateStep1(true);
              goNextStep();
            }} style={{ width: isMobileView ? "100%" : "fit-content" }}>{t("next")}</FormButtonPrimary>
          </Flex>
          <Flex flex={1}> </Flex>
        </Flex>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageTitle = styled.div`
  background-image: url(${process.env.PUBLIC_URL}/images/bg_light_1.png);
  width: 100%;
  height: 100px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PreviousPageBtnText = styled(FormText)`
  font-size: 16px;
  line-height: 26px;
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
`;

const PreviousPageBtn = styled(FormButton)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px;
  width: fit-content;
`;

const Content = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled(ShadowBox)`
  flex-direction: column;
  align-items: self-start;
  padding: 24px;
  gap: 24px;
`;

const Area = styled(Flex)`
  width: 100%;
`;

const AreaTitle = styled(Divider)`
  width: 100%;
  border-block-start: 0 var(--aia-bx-medium-blue-20) !important;
`;

const FormLabelBold = styled(FormLabel)`
  font-weight: bold;
`;

const SaveButton = styled.button`
  flex: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: 10px;
  color: var(--aia-bx-blue-2);
  gap: 3px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;

  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

const SaveButtonText = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  margin-left: 3px;
  text-wrap: nowrap;
  color: var(--aia-bx-dark-blue);
`;

const Img24 = styled.img`
  width: 24px;
  height: 24px;
`;
const Img20= styled.img`
  width: 20px;
  height: 20px;
`;
const Img32 = styled.img`
  width: 32px;
  height: 32px;
`;

/////////////////////////////////////////

const DiseaseBlock = styled(ShadowBox)`
  width: 100%;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: self-start;
  gap: 0px;
`;

const DiseaseBlockTitle = styled(FormText)`
  padding: 8px 24px;
  background-color: var(--aia-bx-bright-blue-10);
  border-top-left-radius: 9px;
  border-bottom-right-radius: 9px;
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
  color: var(--aia-bx-medium-blue-60);
`;

const DiseaseBlockContent = styled(Flex)`
  width: 100%;
  padding: 16px 24px;
  gap: 8px;
  flex-direction: column;
`;

const DiseaseBlockFormField = styled(FormField)`
  width: 100%;
  margin-bottom: 0px;
`;

const ShadowTipDiv =styled.div`
  width:100%;
  border-radius: 8px;
  padding-top: 16px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  box-shadow: 0px 2px 4px 0px #0000004D;
  background-color: #FBFBFB;
  display:flex;
  align-item:center;
  gap:8px;
`
export default Step1;